import src1 from '../assets/toys/1.png';
import src2 from '../assets/toys/2.png';
import src3 from '../assets/toys/3.png';
import src4 from '../assets/toys/4.png';
import src5 from '../assets/toys/5.png';
import src6 from '../assets/toys/6.png';
import src7 from '../assets/toys/7.png';
import src8 from '../assets/toys/8.png';
import src9 from '../assets/toys/9.png';
import src10 from '../assets/toys/10.png';

import src11 from '../assets/toys/11.png';
import src12 from '../assets/toys/12.png';
import src13 from '../assets/toys/13.png';
import src14 from '../assets/toys/14.png';
import src15 from '../assets/toys/15.png';
import src16 from '../assets/toys/16.png';
import src17 from '../assets/toys/17.png';
import src18 from '../assets/toys/18.png';
import src19 from '../assets/toys/19.png';
import src20 from '../assets/toys/20.png';

import src21 from '../assets/toys/21.png';
import src22 from '../assets/toys/22.png';
import src23 from '../assets/toys/23.png';
import src24 from '../assets/toys/24.png';
import src25 from '../assets/toys/25.png';
import src26 from '../assets/toys/26.png';
import src27 from '../assets/toys/27.png';
import src28 from '../assets/toys/28.png';
import src29 from '../assets/toys/29.png';
import src30 from '../assets/toys/30.png';

import src31 from '../assets/toys/31.png';
import src32 from '../assets/toys/32.png';
import src33 from '../assets/toys/33.png';
import src34 from '../assets/toys/34.png';
import src35 from '../assets/toys/35.png';
import src36 from '../assets/toys/36.png';
import src37 from '../assets/toys/37.png';
import src38 from '../assets/toys/38.png';
import src39 from '../assets/toys/39.png';
import src40 from '../assets/toys/40.png';

import src41 from '../assets/toys/41.png';
import src42 from '../assets/toys/42.png';
import src43 from '../assets/toys/43.png';
import src44 from '../assets/toys/44.png';
import src45 from '../assets/toys/45.png';
import src46 from '../assets/toys/46.png';
import src47 from '../assets/toys/47.png';
import src48 from '../assets/toys/48.png';
import src49 from '../assets/toys/49.png';
import src50 from '../assets/toys/50.png';

import src51 from '../assets/toys/51.png';
import src52 from '../assets/toys/52.png';
import src53 from '../assets/toys/53.png';
import src54 from '../assets/toys/54.png';
import src55 from '../assets/toys/55.png';
import src56 from '../assets/toys/56.png';
import src57 from '../assets/toys/57.png';
import src58 from '../assets/toys/58.png';
import src59 from '../assets/toys/59.png';
import src60 from '../assets/toys/59.png';

export const toysData = [src1, src2, src3, src4, src5, src6, src7, src8, src9, src10,
  src11, src12, src13, src14, src15, src16, src17, src18, src19, src20,
  src21, src22, src23, src24, src25, src26, src27, src28, src29, src30,
  src31, src32, src33, src34, src35, src36, src37, src38, src39, src40,
  src41, src42, src43, src44, src45, src46, src47, src48, src49, src50,
  src51, src52, src53, src54, src55, src56, src57, src58, src59, src60];